import store from '../../init/store.js'
/** Return whether or not this rollout exists in my log */
export function hasLoggedRolloutById(id="") {
    const currentRolloutHistory = store.getState().battle.rolloutHistory;
    return currentRolloutHistory.find(rollout => rollout.rolloutId === id);
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/has-logged-rollout-by-id.js